export const environment = {
    production: false,
    // 開発中もリモートサーバー(dev環境)のAPIを使う設定
    apiUrl: 'https://dev.o-e.butinuki.co.jp/api'
};